<div class="invoice-line-items">
  @if (showLabelField()) {
    <div class="invoice-label-wrapper">
      <div class="field-wrapper field-wrapper-full">
        <label class="field-label" for="invoice-line-items-label">
          <span class="required">*</span>{{ labelFieldLabel() }}
        </label>
        <mat-form-field
          appearance="outline"
          class="field-input field-input-rounded"
          [class.field-input-readonly]="isReadonly()"
        >
          <input
            matInput
            id="invoice-line-items-label"
            type="text"
            [value]="label()"
            (input)="updateLabel($any($event.target).value)"
            [placeholder]="labelFieldPlaceholder()"
            [readonly]="isReadonly()"
          />
        </mat-form-field>
      </div>
    </div>
  }

  <div class="invoice-items-table-wrapper" [class]="tableWrapperClass()">
    <table class="invoice-items-table">
      <thead>
        <tr>
          <th class="item-name-header">
            {{ translations.invoiceLineItems.columns.itemName }}
          </th>
          <th class="item-amount-header">
            {{ translations.invoiceLineItems.columns.amount }}
          </th>
          <th class="actions-header"></th>
        </tr>
      </thead>
      <tbody>
        @for (item of items(); track item.id) {
          <tr class="invoice-item-row">
            <td class="item-name-cell">
              <mat-form-field
                appearance="outline"
                class="field-input field-input-rounded"
                [class.field-input-readonly]="isReadonly()"
              >
                <input
                  matInput
                  type="text"
                  [value]="item.itemName"
                  (input)="updateItemName(item.id, $any($event.target).value)"
                  [placeholder]="
                    translations.invoiceLineItems.placeholders.itemName
                  "
                  [readonly]="isReadonly()"
                />
              </mat-form-field>
            </td>
            <td class="item-amount-cell">
              <mat-form-field
                appearance="outline"
                class="field-input field-input-rounded"
                [class.field-input-readonly]="isReadonly()"
              >
                <span matPrefix>{{ currencySymbol() }}</span>
                <input
                  matInput
                  type="number"
                  [value]="item.itemAmount ?? ''"
                  (input)="updateItemAmount(item.id, $any($event.target).value)"
                  [placeholder]="
                    translations.invoiceLineItems.placeholders.amount
                  "
                  step="0.01"
                  min="0"
                  [readonly]="isReadonly()"
                />
              </mat-form-field>
            </td>
            <td class="actions-cell">
              <button
                mat-icon-button
                type="button"
                class="delete-button"
                [attr.aria-label]="translations.invoiceLineItems.deleteRow"
                [disabled]="
                  !canDeleteRow(item.id) ||
                  deletingItemId() === item.id ||
                  isReadonly()
                "
                (click)="removeLineItem(item.id)"
              >
                @if (deletingItemId() === item.id) {
                  <mat-spinner diameter="20"></mat-spinner>
                } @else {
                  <mat-icon class="material-icons">delete</mat-icon>
                }
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="add-line-item-wrapper">
    <button
      mat-button
      type="button"
      class="add-line-item-button"
      [disabled]="!allRowsValid() || isReadonly()"
      (click)="addLineItem()"
    >
      <mat-icon class="material-icons-outlined">add_circle_outline</mat-icon>
      {{ translations.invoiceLineItems.addLineItem }}
    </button>
  </div>
</div>
